/* eslint-disable no-undef */
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
// import XYZ from 'ol/source/XYZ';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import TileWMS from 'ol/source/TileWMS';
import GeoJSON from 'ol/format/GeoJSON';
import { Projection, addProjection, fromLonLat, toLonLat, get as getProjection } from 'ol/proj';
import VectorSource from 'ol/source/Vector';
// eslint-disable-next-line no-unused-vars
import { Fill, RegularShape, Circle, Stroke, Style, Text, Icon } from 'ol/style';
import Overlay from 'ol/Overlay';
import Select from 'ol/interaction/Select';
import { MouseWheelZoom, defaults, Draw } from 'ol/interaction';
import { always, platformModifierKeyOnly } from 'ol/events/condition.js';
import { pointerMove, singleClick } from 'ol/events/condition';
import KMLSource from 'ol/format/KML';
import Feature from 'ol/Feature';
import { Polygon, MultiPolygon, Point, LineString } from 'ol/geom';
import { getVectorLayer, getLayerCoordinatesValues } from '@/api/services.js';
import TileGrid from 'ol/tilegrid/TileGrid';
import { getWidth, containsExtent, intersects } from 'ol/extent';
import * as Control from 'ol/control';
import { getArea, getLength } from 'ol/sphere';
import router from '@/router/index.js';
import { S3_BUCKETS, log } from '@/constants.js';
import { getFormattedDate, getFeaturePosition, getRgbFromColor } from '@/utils.js';
import shp from 'shpjs';
import Vue from 'vue';
import { MAPBOX_TOKEN, MAPBOX_STYLE } from '@/constants';
import Layer from 'ol/layer/Layer';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';

const MAP_LATITUDE_LIMIT = 84.9;
const MAP_EXTENT = [
  Number.NEGATIVE_INFINITY,
  fromLonLat([0, -MAP_LATITUDE_LIMIT])[1],
  Number.POSITIVE_INFINITY,
  fromLonLat([0, MAP_LATITUDE_LIMIT])[1]
];

const WEB_MERCATOR_WORLD_WIDTH = getWidth(getProjection('EPSG:3857').getExtent());

const getWorldAlignedBBox = (viewportExtent, domainExtent, worldWidth = WEB_MERCATOR_WORLD_WIDTH) => {
  const domainCenterX = (domainExtent[0] + domainExtent[2]) / 2;
  const worldOffsetOf = (x) => Math.round((domainCenterX - x) / worldWidth) * worldWidth;
  const leftOffset = worldOffsetOf(viewportExtent[0]);
  const rightOffset = worldOffsetOf(viewportExtent[2]);

  if (leftOffset !== rightOffset) {
    return [domainExtent[0], viewportExtent[1], domainExtent[2], viewportExtent[3]];
  }

  return [viewportExtent[0] + leftOffset, viewportExtent[1], viewportExtent[2] + leftOffset, viewportExtent[3]];
};

export const state = {
  googleMap: null,
  marker: null,
  geocoder: null,
  OLmap: null,
  MBmap: null,
  animationInterval: null,
  rasterFrontLayer: null,
  rasterBackLayer: null,
  lastZoom: null,
  mapLocale: 'Italian',
  mapTypeId: 'terrain',
  measureToolValue: '',
  locationName: '',
  latitude: '',
  longitude: '',
  address: '',
  addressProv: '',
  placeAddress: '',
  serviceSelectedId: '',
  lastUpdatedLayerDate: '',
  ticketing_formatted_address: '',
  selectedFeatureLayerName: '',
  selectedFeatureServiceID: '',
  selectedFeatureCheckParam: '',
  rasterMarkerLabel: '',
  rasterMarkerUdm: '',
  rasterMarkerValue: '',
  rasterMarkerRows: [],
  rasterMarkerDate: '',
  clickedPlace: '',
  mouseCoord: '',
  sliderOpacityValue: 60,
  selectedFeatureDigits: 0,
  zoom: 5,
  meteogramActive: false,
  measureToolActive: false,
  rasterVisible: true,
  disableAnimationPlay: false,
  geocoderResponse: false,
  isCenterMarker: false,
  isVectorPopup: false,
  sendCenterEvent: false,
  sendClickEvent: false,
  isPopupMarker: true,
  reloadLegend: false,
  legendMenu: false,
  layerToSelectVector: {},
  layerToSelectRaster: {},
  refreshIntervalID: {},
  colorFill: {},
  colorStroke: {},
  strokeWidth: {},
  zIndexValue: {},
  legend_vectorRules: {},
  catastoPopupData: {},
  selectedRasterLayer: {},
  selectedFeatureObj: {},
  renderOpacityMenu: {},
  runtime: {},
  vectorParamRange: {},
  aggregationIntervals: {},
  savedGridFeatures: {},
  specificDefaultService: { Archive: false, RealTime: false, Forecast: false },
  isRefreshingDataServiceID: [],
  isAnimating: [],
  coordsLonLat: [],
  distanceFromPoint: [],
  userLocation: [],
  vectorTableHeaders: [],
  vectorBBOX: [],
  selectedFeaturePosition: [],
  mapPadding: [0, 0, 0, 0],
  mapCenter: [1594684.1859, 4985987.3737],
  ignoreProperties: ['geometry', 'ignore_id', 'type_property', 'virtual_station', 'geom_property', 'no_standard_property', 'added_feature'],
  mapStyle: 'classic',
  landmark: new Overlay({
    positioning: 'bottom-center',
    stopEvent: true
  }),
  popup: new Overlay({
    positioning: 'bottom-center',
    stopEvent: true
  }),
  globalLayerPopup: new Overlay({
    positioning: 'center-left',
    offset: [10, 0],
    element: document.createElement('div')
  }),
  select: new Select({
    layers: function (layer) {
      return layer.values_.layer_type === 'VECTOR';
    },
    condition: singleClick,
    style: false
  })
  // OLLayers: [
  //   new TileLayer({
  //     source: new XYZ({
  //       url: 'https://mt0.google.com/vt/lyrs=m&hl=it&x={x}&y={y}&z={z}'
  //     })
  //   })
  // ]
};

export const mutations = {};

export const actions = {
  setCoordinates({ state }, { latitude, longitude }) {
    state.latitude = latitude;
    state.longitude = longitude;
  },
  // ------------------------ MAP ---------------------------
  initiateGoogleMapAction({ state, dispatch }, mapId) {
    try {
      const mapOptions = {
        zoom: 5,
        center: { lat: 45.29509029836977, lng: 11.819342135290803 },
        mapTypeId: 'terrain',
        mapTypeControl: false,
        streetViewControl: false,
        zoomControl: false,
        options: {
          gestureHandling: 'greedy'
        }
      };
      state.googleMap = new google.maps.Map(
        document.getElementById(mapId),
        mapOptions
      );

      if (mapId === 'ticketingMap') {
        state.geocoder = new google.maps.Geocoder();
        dispatch('setGeocoderMarker');
        dispatch('manualGeocoderMarker');
      }
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'initiateGoogleMapAction',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  initiateOLMapAction({ rootState, state, dispatch, commit }, isMobile) {
    try {
      mapboxgl.accessToken = MAPBOX_TOKEN;
      state.MBmap = new mapboxgl.Map({
        projection: 'mercator',
        style: `mapbox://styles/${MAPBOX_STYLE[state.mapStyle]}`,
        attributionControl: false,
        boxZoom: false,
        center: toLonLat(state.mapCenter),
        container: 'map',
        language: state.mapLocale,
        locale: state.mapLocale,
        doubleClickZoom: false,
        dragPan: false,
        dragRotate: false,
        // interactive: false,
        keyboard: false,
        pitchWithRotate: false,
        scrollZoom: false,
        touchZoomRotate: false,
        logoPosition: isMobile ? 'top-left' : 'bottom-right'
      });

      const MBLayers = new Layer({
        render: function (frameState) {
          const canvas = state.MBmap.getCanvas();
          const viewState = frameState.viewState;

          const visible = MBLayers.getVisible();
          canvas.style.display = visible ? 'block' : 'none';

          const opacity = MBLayers.getOpacity();
          canvas.style.opacity = opacity;

          // adjust view parameters in mapbox
          const rotation = viewState.rotation;
          state.MBmap.jumpTo({
            center: toLonLat(viewState.center),
            zoom: viewState.zoom - 1,
            bearing: (-rotation * 180) / Math.PI,
            animate: false
          });

          // cancel the scheduled update & trigger synchronous redraw
          // see https://github.com/mapbox/mapbox-gl-js/issues/7893#issue-408992184
          if (state.MBmap._frame) {
            state.MBmap._frame.cancel();
            state.MBmap._frame = null;
          }

          state.MBmap._render();

          return canvas;
        }
      });

      state.OLmap = new Map({
        layers: [MBLayers],
        interactions: defaults({
          mouseWheelZoom: false,
          doubleClickZoom: false,
          altShiftDragRotate: false,
          pinchRotate: false
        }).extend([
          new MouseWheelZoom({
            constrainResolution: true,
            condition: router.currentRoute.path.includes('reports')
              ? platformModifierKeyOnly
              : always
          })
        ]),
        target: 'map',
        view: new View({
          // projection: 'EPSG:4326',
          padding: state.mapPadding,
          center: state.mapCenter,
          extent: MAP_EXTENT,
          smoothExtentConstraint: false,
          minZoom: 3,
          // center: transform(getCenter(ETRS89Extent), ETRS89proj, 'EPSG:3857'),
          zoom: state.zoom
        })
      });

      if (!router.currentRoute.path.includes('reports')) {
        dispatch('setMarkerOnClick');
        // dispatch('reloadVectorLayerAfterZoom');

        const selectPointerMove = new Select({
          layers: function (layer) {
            return layer.values_.layer_type === 'VECTOR';
          },
          condition: pointerMove,
          style: false
        });

        state.OLmap.addInteraction(selectPointerMove);
        state.OLmap.addInteraction(state.select);

        //   state.OLmap.removeOverlay(state.landmark);
        //   state.landmark.setPosition(undefined);

        // selectPointerMove.on('pointermove', function () {
        // });

        state.OLmap.on('moveend', function () {
          state.vectorBBOX = state.OLmap.getView().calculateExtent(state.OLmap.getSize());

          const centerCoordinates = toLonLat(state.OLmap.getView().getCenter());
          const timeStamp = Date.now();

          state.OLmap.getLayers().getArray().slice(1).forEach(layer => {
            if (layer.values_.layer_type === 'VECTOR') {
              Vue.$gtag.event('Centroide mappa', {
                event_category: `${router.currentRoute.params.id == undefined ? 'Home' : router.currentRoute.params.id} - Lat ${centerCoordinates[1].toFixed(4)} - Lon ${centerCoordinates[0].toFixed(4)}`,
                event_label: `${timeStamp} - ${rootState.app_user.username} - ${rootState.app_user.crm_id} - ${getFormattedDate(new Date(), true, true)}`,
                value: `${layer.values_.service_name}: ${layer.values_.layer_name.split(':')[1]} - ${getFormattedDate(new Date(layer.values_.time.split('/')[0]), true)} - ${getFormattedDate(new Date(layer.values_.time.split('/')[1]), true)}`
              });
            }

            if (layer.values_.layer_type === 'RASTER') {
              Vue.$gtag.event('Centroide mappa', {
                event_category: `${router.currentRoute.params.id == undefined ? 'Home' : router.currentRoute.params.id} - Lat ${centerCoordinates[1].toFixed(4)} - Lon ${centerCoordinates[0].toFixed(4)}`,
                event_label: `${timeStamp} - ${rootState.app_user.username} - ${rootState.app_user.crm_id} - ${getFormattedDate(new Date(), true, true)}`,
                value: `${layer.values_.service_name}: ${layer.values_.layer_name.split(':')[1]} - ${getFormattedDate(new Date(layer.values_.source.params_.TIME), true)}`
              });
            }
          });
        });

        state.select.on('select', function (e) {
          if (e.selected.length > 0) {
            state.isVectorPopup = true;
            state.isPopupMarker = false;
            const featureID = e.selected[0].ol_uid;
            state.selectedFeatureLayerName = e.target.featureLayerAssociation_[featureID].values_.layer_name;
            state.selectedFeatureObj = e.selected[0].values_;
            state.selectedFeatureCheckParam = e.selected[0].values_.ignore_id || e.selected[0].values_.radarmeteo_id || e.selected[0].values_.area || e.selected[0].values_.Area;
            state.selectedFeaturePosition = getFeaturePosition(e.selected[0]);
            const popupPosition = e.selected[0].getGeometry().getType() === 'Point'
              ? e.selected[0].getGeometry().flatCoordinates
              : e.mapBrowserEvent.coordinate;
            state.popup.setPosition(popupPosition);
            state.popup.setElement(document.getElementById('popup'));
            state.OLmap.addOverlay(state.popup);
            state.popup.panIntoView();

            state.selectedFeatureServiceID = '';

            state.OLmap.getLayers().getArray().slice(1).forEach(layer => {
              if (layer.values_.layer_name.includes(state.selectedFeatureLayerName.split(':')[1])) {
                state.selectedFeatureServiceID = layer.values_.service_id;
              }
            });

            const data = {
              service_id: state.selectedFeatureServiceID,
              feature_id: state.selectedFeatureObj.ignore_id
            };

            commit('GET_FILTERED_CHART_ITEMS', data);
          } else {
            dispatch('closePopupOnMap');
          }
        });
      }

      state.OLmap.on('click', async function (evt) {
        state.catastoPopupData = {};

        if (router.currentRoute.path.includes('ticketing-request')) {
          dispatch('fetchDatiCatastali', evt.coordinate);
        }
      });

      state.OLmap.on('pointermove', function (e) {
        state.mouseCoord = toLonLat(e.coordinate);
      });
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'initiateOLMapAction',
          errObj: err,
          type: 'danger'
        },
        { root: true }
      );
    }

    state.OLmap.getControls().forEach(control => {
      if (control instanceof Control.Zoom) {
        state.OLmap.removeControl(control);
      }
    });

    state.OLmap.on('click', function (event) {
      state.OLmap.forEachFeatureAtPixel(event.pixel, function (feature, layer) {
        state.isVectorPopup = layer.values_.layer_type === 'VECTOR';

        return true;
      });
    });
    state.OLmap.addOverlay(state.globalLayerPopup);
  },
  async removeLayer({ state, dispatch }, data) {
    await state.OLmap.getLayers().getArray().slice(1).forEach(async layer => {
      if (data === layer.values_.layer_name) {
        await state.OLmap.removeLayer(layer);
        layer.getSource()?.clear(true);
        layer.dispose?.();

        if (layer.values_.layer_type === 'VECTOR') {
          dispatch('removeVectorLayer', layer);
        } else if (layer.values_.layer_type === 'RASTER') {
          state.rasterFrontLayer = null;
          state.rasterBackLayer = null;
        }
      }
    });
  },
  async removeLayerByServiceID({ state, dispatch }, data) {
    if (data) {
      await state.OLmap.getLayers().getArray().slice(1).forEach(async layer => {
        if (layer.values_.service_id === data) {
          await state.OLmap.removeLayer(layer);
          layer.getSource()?.clear(true);
          layer.dispose?.();

          if (layer.values_.layer_type === 'VECTOR') {
            dispatch('removeVectorLayer', layer);
          } else if (layer.values_.layer_type === 'RASTER') {
            state.rasterFrontLayer = null;
            state.rasterBackLayer = null;
          }
        }
      });
    }
  },
  async removeEveryRasterLayer({ state, dispatch }) {
    await state.OLmap.getLayers().getArray().slice(1).forEach(async layer => {
      if (layer.values_.layer_type === 'RASTER') {
        await state.OLmap.removeLayer(layer);
        layer.getSource()?.clear(true);
        layer.dispose?.();

        state.rasterFrontLayer = null;
        state.rasterBackLayer = null;
      }
    });

    if (state.coordsLonLat.length === 2) {
      dispatch('setRasterMarkerValue');
    }
  },
  async removeEveryLayer({ state, dispatch }) {
    state.OLmap.getLayers().getArray().slice(1).forEach(layer => {
      if (layer.values_.layer_type !== 'GLOBAL LAYER' && layer.values_.layer_type !== 'CUSTOMER LAYER') {
        state.OLmap.removeLayer(layer);
        layer.getSource()?.clear(true);
        layer.dispose?.();

        if (layer.values_.layer_type === 'VECTOR') {
          dispatch('removeVectorLayer', layer);
        } else if (layer.values_.layer_type === 'RASTER') {
          state.rasterFrontLayer = null;
          state.rasterBackLayer = null;
        }
      }
    });
  },
  async removeVectorLayer({ rootState, state, dispatch }, layer) {
    if (layer.values_.service_id === state.selectedFeatureServiceID) {
      dispatch('closePopupOnMap');
    }

    delete rootState.geoserver_data.vectorLegend_selectedLabel[layer.values_.layer_name];
    delete state.vectorParamRange[layer.values_.service_id];

    //remove listener
    if (layer._vectorUpdateHandler) {
      state.OLmap.un('moveend', layer._vectorUpdateHandler);
      delete layer._vectorUpdateHandler;
    }
  },
  checkOpacityServiceID({ state }, id) {
    state.OLmap.getLayers().getArray().slice(1).forEach(layer => {
      if (layer.values_.service_id === id && layer.values_.layer_type !== 'METEOGRAM') {
        return state.sliderOpacityValue = layer.getOpacity() * 100;
      }
    });
  },
  setGeocoderMarker({ state }) {
    google.maps.event.addListener(state.googleMap, 'click', (event) => {
      setTimeout(function () {
        state.latitude = event.latLng.lat();
        state.longitude = event.latLng.lng();
        const latlng = {
          lat: state.latitude,
          lng: state.longitude
        };
        state.geocoder
          .geocode({ location: latlng })
          .then((response) => {
            if (response.results[0]) {
              let place = '';
              let prov = '';
              response.results[0].address_components.forEach(item => {
                if (item.types[0] === 'administrative_area_level_3') {
                  place += item.short_name;
                }

                if (item.types[0] === 'administrative_area_level_2') {
                  if (place !== '') {
                    place += ` (${item.short_name})`;
                  }

                  prov = `${item.long_name.replace('Città Metropolitana di ', '').replace('Provincia di ', '')} (${item.short_name})`;
                }
              });

              if (place === '') {
                if (response.results[0].address_components[0].types[0] === 'plus_code') {
                  const toRemove = response.results[0].address_components[0].long_name;
                  place = response.results[0].formatted_address.replace(toRemove, '');
                } else {
                  place = response.results[0].formatted_address;
                }
              }

              state.address = place;
              state.addressProv = prov;
            } else {
              window.alert('No results found');
            }
          })
          .catch((e) => window.alert('Geocoder failed due to: ' + e));

        if (!state.marker) {
          state.marker = new google.maps.Marker({
            map: state.googleMap
          });
        }

        state.marker.setPosition(event.latLng);
      }, 500);
    });
  },
  manualGeocoderMarker({ state }) {
    document.getElementById('submit').addEventListener('click', () => {
      setTimeout(function () {
        if (state.geocoder != undefined) {
          const latitude = document.getElementById('lat').value;
          const longitude = document.getElementById('lng').value;
          const latlng = {
            lat: parseFloat(latitude),
            lng: parseFloat(longitude)
          };
          state.geocoder
            .geocode({ location: latlng })
            .then((response) => {
              if (response.results[0]) {
                let place = '';
                let prov = '';
                response.results[0].address_components.forEach(item => {
                  if (item.types[0] === 'administrative_area_level_3') {
                    place += item.short_name;
                  }

                  if (item.types[0] === 'administrative_area_level_2') {
                    if (place !== '') {
                      place += ` (${item.short_name})`;
                    }

                    prov = `${item.long_name.replace('Città Metropolitana di ', '').replace('Provincia di ', '')} (${item.short_name})`;
                  }
                });

                if (place === '') {
                  if (response.results[0].address_components[0].types[0] === 'plus_code') {
                    const toRemove = response.results[0].address_components[0].long_name;
                    place = response.results[0].formatted_address.replace(toRemove, '');
                  } else {
                    place = response.results[0].formatted_address;
                  }
                }

                state.address = place;
                state.addressProv = prov;
              } else {
                window.alert('No results found');
              }
            })
            .catch((e) => window.alert('Geocoder failed due to: ' + e));

          if (!state.marker) {
            state.marker = new google.maps.Marker({
              map: state.googleMap
            });
          }

          state.marker.setPosition(latlng);
        }
      }, 500);
    });
  },
  changeViewPadding({ state }) {
    const view = new View({
      padding: state.mapPadding,
      center: state.mapCenter,
      extent: MAP_EXTENT,
      smoothExtentConstraint: false,
      minZoom: 3,
      zoom: state.zoom
    });
    state.OLmap.setView(view);
  },
  newMapCenter({ state, dispatch }, newCoord) {
    if (router.currentRoute.name !== 'TicketingRequest') {
      state.distanceFromPoint = newCoord;
      state.isCenterMarker = false;
      state.isPopupMarker = true;
      state.select.getFeatures().clear();
      dispatch('reverseGeocoding', newCoord);
      dispatch('closePopupOnMap');
      state.landmark.setPosition(newCoord);
      state.landmark.setElement(document.getElementById('landmark'));
      state.OLmap.addOverlay(state.landmark);
    }

    dispatch('changeViewPadding');
    state.OLmap.getView().setCenter(newCoord);

    const actualZoom = state.OLmap.getView().getZoom();
    state.OLmap.getView().setZoom((actualZoom <= 13) ? 13 : actualZoom);
  },
  zoomIn({ state }) {
    const view = state.OLmap.getView();
    const actualZoom = view.getZoom();

    if (actualZoom < 22) {
      view.animate({
        zoom: actualZoom + 0.25,
        duration: 200
      });
    }
  },
  zoomOut({ state }) {
    const view = state.OLmap.getView();
    const actualZoom = view.getZoom();

    if (actualZoom > 1) {
      view.animate({
        zoom: actualZoom - 0.25,
        duration: 200
      });
    }
  },
  setZoomUser({ state }, data) {
    state.zoom = data;
    state.OLmap.getView().setZoom(state.zoom);
  },
  async getLocation({ state }) {
    if (!navigator.geolocation || !navigator.permissions) {
      /* eslint-disable-next-line no-console */
      console.info('Geolocation or Permissions API is not supported by this browser.');

      return;
    }


    try {
      const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });

      if (permissionStatus.state === 'granted') {
        navigator.geolocation.getCurrentPosition((position) => {
          state.userLocation = fromLonLat([position.coords.longitude, position.coords.latitude], 'EPSG:3857');
        });
      } else if (permissionStatus.state === 'prompt') {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            state.userLocation = fromLonLat([position.coords.longitude, position.coords.latitude], 'EPSG:3857');
          },
          (error) => {
            /* eslint-disable-next-line no-console */
            console.error('Error getting location: ', error);
          }
        );
      } else if (permissionStatus.state === 'denied') {
        alert('Access to location has been denied. Please enable location access in your browser settings.');
      }

      permissionStatus.onchange = () => {
        /* eslint-disable-next-line no-console */
        console.info('Permission state changed to:', permissionStatus.state);
      };
    } catch (error) {
      /* eslint-disable-next-line no-console */
      console.error('Error checking or requesting geolocation permission:', error);
    }
  },
  closePopupOnMap({ state }) {
    state.popup.setPosition(undefined);
    state.isVectorPopup = false;
    state.selectedFeatureServiceID = '';
    state.selectedFeatureCheckParam = '';
    state.selectedFeaturePosition = [];
  },
  setMarkerOnClick({ state, dispatch }) {
    state.OLmap.on('dblclick', async function (evt) {
      if (!state.measureToolActive && router.currentRoute.name !== 'TicketingRequest') {
        state.sendCenterEvent = false;
        state.sendClickEvent = true;
        state.distanceFromPoint = evt.coordinate;
        state.rasterMarkerLabel = '';
        state.rasterMarkerUdm = '';
        state.rasterMarkerValue = '';
        state.isCenterMarker = false;
        state.isPopupMarker = true;
        state.select.getFeatures().clear();

        dispatch('reverseGeocoding', evt.coordinate);

        dispatch('closePopupOnMap');
        state.landmark.setPosition(evt.coordinate);
        state.landmark.setElement(document.getElementById('landmark'));
        state.OLmap.addOverlay(state.landmark);
        state.landmark.panIntoView();

        dispatch('setRasterMarkerValue');
      }
    });
  },
  removeMarkerFromMap({ state }) {
    if (state.OLmap && state.landmark) {
      state.landmark.setPosition(undefined); // nasconde
      state.coordsLonLat = []; //svuota vettore coordinate
      state.distanceFromPoint = []; //svuota vettore coordinate
    }
  },
  async setRasterMarkerValue({ state, rootState }) {
    const activeRaster = state.OLmap.getLayers().getArray().slice(1).some(layer => layer.values_.layer_type === 'RASTER');

    if (activeRaster) {
      const raster = state.OLmap.getLayers().getArray().slice(1).filter(layer => layer.values_.layer_type === 'RASTER');
      const [workspace, layer] = raster[0].values_.layer_name.split(':');
      const markerLayers = raster[0].values_.is_multi_variable && raster[0].values_.multi_variable_layers.length > 0
        ? raster[0].values_.multi_variable_layers
        : [layer];
      const date = new Date(state.rasterMarkerDate);
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const data = {
        time: date.toISOString(),
        username: rootState.app_user.username,
        workspace: workspace,
        layers: markerLayers,
        latitude: state.coordsLonLat[1],
        longitude: state.coordsLonLat[0],
        output: 'json',
        timezone: timeZone,
        service_name: raster[0].values_.service_name,
        service_id: raster[0].values_.service_id,
        udm_conversions: raster[0].values_.udm_conversions,
        group: router.currentRoute.params.id,
        runtime: state.runtime[raster[0].values_.service_id]
      };

      try {
        const resp = await getLayerCoordinatesValues(data);

        if (raster[0].values_.is_multi_variable) {
          state.rasterMarkerLabel = '';
          state.rasterMarkerUdm = '';
          state.rasterMarkerValue = '';
          state.rasterMarkerRows = markerLayers.map(layerName => {
            const layerKey = `${workspace}:${layerName}`;
            const value = resp.data.data[layerKey]?.[0];
            const component = raster[0].values_.multi_variable_layer_configs?.find(item => item.layer_name === layerName);

            return {
              label: `${layerKey}_serviceID:${raster[0].values_.service_id}.label`,
              udm: component?.udm,
              value: typeof value === 'number' ? value.toFixed(1) : 'N/A'
            };
          });
        } else {
          state.rasterMarkerRows = [];
          state.rasterMarkerLabel = `${raster[0].values_.layer_name}_serviceID:${raster[0].values_.service_id}.label`;
          state.rasterMarkerUdm = raster[0].values_.udm;
          state.rasterMarkerValue = `: ${resp.data.data[raster[0].values_.layer_name][0].toFixed(1)}`;
        }
      } catch {
        state.rasterMarkerLabel = '';
        state.rasterMarkerUdm = '';
        state.rasterMarkerValue = '';
        state.rasterMarkerRows = [];
      }
    } else {
      state.rasterMarkerLabel = '';
      state.rasterMarkerUdm = '';
      state.rasterMarkerValue = '';
      state.rasterMarkerRows = [];
    }
  },
  reverseGeocoding({ rootState, state }, coord) {
    state.coordsLonLat = toLonLat(coord);
    const latlng = {
      lat: state.coordsLonLat[1],
      lng: state.coordsLonLat[0]
    };

    const reverseGeocoding = new google.maps.Geocoder();
    reverseGeocoding
      .geocode({ location: latlng })
      .then((response) => {
        state.geocoderResponse = true;

        if (response.results[0].address_components[0].types[0] === 'plus_code') {
          const toRemove = response.results[0].address_components[0].long_name;
          state.placeAddress = response.results[0].formatted_address.replace(toRemove, '');
        } else {
          state.placeAddress = response.results[0].formatted_address;
        }

        state.clickedPlace = '';
        response.results[0].address_components.forEach(item => {
          if (item.types[0] === 'administrative_area_level_3') {
            state.clickedPlace += item.short_name;
          }

          if (state.clickedPlace !== '' && item.types[0] === 'administrative_area_level_2') {
            state.clickedPlace += ` (${item.short_name})`;
          }
        });

        if (state.clickedPlace === '') {
          if (response.results[0].address_components[0].types[0] === 'plus_code') {
            const toRemove = response.results[0].address_components[0].long_name;
            state.clickedPlace = response.results[0].formatted_address.replace(toRemove, '');
          } else {
            state.clickedPlace = response.results[0].formatted_address;
          }
        }

        if (state.sendCenterEvent) {
          Vue.$gtag.event('Geolocalizzazione', {
            event_category: `${router.currentRoute.params.id == undefined ? 'Home' : router.currentRoute.params.id}`,
            event_label: `${Date.now()} - ${rootState.app_user.username} - ${rootState.app_user.crm_id} - ${getFormattedDate(new Date(), true, true)}`,
            value: `${state.clickedPlace} - Lat ${state.coordsLonLat[1]} - Lon ${state.coordsLonLat[0]}`
          });
        }

        if (state.sendClickEvent) {
          Vue.$gtag.event('Località selezionata su mappa', {
            event_category: `${router.currentRoute.params.id == undefined ? 'Home' : router.currentRoute.params.id}`,
            event_label: `${Date.now()} - ${rootState.app_user.username} - ${rootState.app_user.crm_id} - ${getFormattedDate(new Date(), true, true)}`,
            value: `${state.clickedPlace} - Lat ${state.coordsLonLat[1]} - Lon ${state.coordsLonLat[0]}`
          });
        }
      })
      .catch((e) => {
        if (e) {
          state.geocoderResponse = false;
          state.placeAddress = 'Address not found';
        }
      });
    state.coordsLonLat[1] = state.coordsLonLat[1].toFixed(4);
    state.coordsLonLat[0] = state.coordsLonLat[0].toFixed(4);
  },
  ticketingReverseGeocoding({ state }, coord) {
    const [longitude, latitude] = coord;
    const latlng = {
      lat: parseFloat(latitude),
      lng: parseFloat(longitude)
    };

    const reverseGeocoding = new google.maps.Geocoder();

    return reverseGeocoding
      .geocode({ location: latlng })
      .then((response) => {
        if (response.results[0]) {
          let place = '';
          let prov = '';
          response.results[0].address_components.forEach(item => {
            if (item.types[0] === 'administrative_area_level_3') {
              place += item.short_name;
            }

            if (item.types[0] === 'administrative_area_level_2') {
              if (place !== '') {
                place += ` (${item.short_name})`;
              }

              prov = `${item.long_name.replace('Città Metropolitana di ', '').replace('Provincia di ', '')} (${item.short_name})`;
            }
          });

          if (place === '') {
            if (response.results[0].address_components[0].types[0] === 'plus_code') {
              const toRemove = response.results[0].address_components[0].long_name;
              place = response.results[0].formatted_address.replace(toRemove, '');
            } else {
              place = response.results[0].formatted_address;
            }
          }

          state.ticketing_formatted_address = response.results[0].formatted_address;
          state.address = place || 'SNC';
          state.addressProv = prov || 'SNC';
        } else {
          window.alert('No results found');
        }
      })
      .catch((e) => window.alert('Geocoder failed due to: ' + e));
  },
  setPositionUser({ state }, data) {
    const lat = data[0];
    const long = data[1];
    state.mapCenter = fromLonLat([long, lat], 'EPSG:3857');
  },
  async toggleMeasureTool({ state }, toolType) {
    state.measureToolValue = '0.00 m';

    const vectorLayer = new VectorLayer({
      source: new VectorSource(),
      style: [new Style({
        stroke: new Stroke({
          color: '#000',
          width: 3
        }),
        fill: new Fill({ color: [255, 255, 255, 0.5] })
      })]
    });

    const areaInteraction = new Draw({
      type: 'Polygon',
      source: vectorLayer.getSource()
    });
    const distanceInteraction = new Draw({
      type: 'LineString',
      source: vectorLayer.getSource()
    });

    for await (const layer of state.OLmap.getLayers().getArray()) {
      if (layer.values_.layer_name === 'MEASURING TOOL') {
        await state.OLmap.removeLayer(layer);
        layer.getSource()?.clear(true);
        layer.dispose?.();
      }
    }

    state.OLmap.getInteractions().forEach(interaction => {
      if (interaction instanceof Draw) {
        state.OLmap.removeInteraction(interaction);
      }

      if (interaction instanceof Select) {
        interaction.setActive(toolType === '');
      }
    });

    if (toolType !== '') {
      state.measureToolActive = true;

      if (toolType === 'area') {
        state.OLmap.addInteraction(areaInteraction);
        areaInteraction.on('drawstart', function (event) {
          vectorLayer.getSource().clear();

          event.feature.on('change', function (event) {
            const measureArea = getArea(event.target.getGeometry());
            state.measureToolValue = measureArea > 9999.99 ? (Math.round((measureArea / 1000000) * 100) / 100).toFixed(2) + ' km' : (Math.round(measureArea * 100) / 100).toFixed(2) + ' m';
          });
        });
      }

      if (toolType === 'distance') {
        state.OLmap.addInteraction(distanceInteraction);
        distanceInteraction.on('drawstart', function (event) {
          vectorLayer.getSource().clear();

          event.feature.on('change', function (event) {
            const measureLenght = getLength(event.target.getGeometry());
            state.measureToolValue = measureLenght > 999.99 ? (Math.round((measureLenght / 1000) * 100) / 100).toFixed(2) + ' km' : (Math.round(measureLenght * 100) / 100).toFixed(2) + ' m';
          });
        });
      }

      vectorLayer.set('layer_type', toolType);
      vectorLayer.set('layer_name', 'MEASURING TOOL');
      vectorLayer.setZIndex(5);
      state.OLmap.addLayer(vectorLayer);
    } else {
      state.measureToolActive = false;
    }
  },
  setMapStyle({ state }, style) {
    state.mapStyle = style;
    state.MBmap.setStyle(`mapbox://styles/${MAPBOX_STYLE[style]}`, { diff: false });
  },
  // ------------------------ CATASTO ---------------------------
  async loadCatastoLayer({ state }) {
    const ETRS89Extent = [5.93, 34.76, 18.99, 47.1];
    proj4.defs('EPSG:6706', '+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs');
    register(proj4);

    const ETRS89proj = new Projection({
      code: 'EPSG:6706',
      extent: ETRS89Extent
    });
    addProjection(ETRS89proj);

    // addCoordinateTransforms( // from 'ol/proj'
    //   'EPSG:6706',
    //   'EPSG:3857',
    //   coord => proj4('EPSG:6706', 'EPSG:3857', coord),
    //   coord => proj4('EPSG:3857', 'EPSG:6706', coord)
    // );

    const startResolution = getWidth(ETRS89Extent);
    let resolutions = Array.apply(null, new Array(22));
    resolutions = resolutions.map((item, index) => item = startResolution / Math.pow(2, index));

    const tileGrid = new TileGrid({
      extent: ETRS89Extent,
      resolutions: resolutions,
      tileSize: [1024, 1024]
    });

    const catastoLayer = new TileLayer({
      source: new TileWMS({
        projection: ETRS89proj,
        url: 'https://wms.cartografia.agenziaentrate.gov.it/inspire/wms/ows01.php',
        params: {
          // LAYERS: ['CP.CadastralZoning', 'strade', 'acque', 'CP.CadastralParcel', 'fabbricati', 'vestizioni', 'province', 'codice_plla', 'simbolo_graffa'],
          LAYERS: ['CP.CadastralZoning', 'CP.CadastralParcel', 'fabbricati', 'codice_plla', 'simbolo_graffa'],
          FORMAT: 'image/png',
          SRS: 'EPSG:6706',
          VERSION: '1.1.1'
        },
        serverType: 'mapserver',
        tileGrid: tileGrid
      })
    });

    catastoLayer.set('layer_type', 'CATASTO');
    catastoLayer.set('layer_name', 'DATI CATASTALI');

    state.OLmap.addLayer(catastoLayer);
  },
  async fetchDatiCatastali({ state }, coordinate) {
    const [lon, lat] = toLonLat(coordinate);
    const url = `https://wms.cartografia.agenziaentrate.gov.it/inspire/ajax/ajax.php?op=getDatiOggetto&lon=${lon}&lat=${lat}`;

    if (lon && lat) {
      try {
        const response = await fetch(url);
        const data = await response.json();
        state.catastoPopupData = data;
        /* eslint-disable-next-line no-console */
        // console.info('[DATI CATASTALI]', data);
      } catch (error) {
        state.catastoPopupData = {};
        /* eslint-disable-next-line no-console */
        console.error('[Error]', error);
      }
    }
  },
  async removeCatastoLayer({ state }) {
    for await (const layer of state.OLmap.getLayers().getArray()) {
      if (layer.values_.layer_type === 'CATASTO') {
        await state.OLmap.removeLayer(layer);
        layer.getSource()?.clear(true);
        layer.dispose?.();
      }
    }
  },
  // ------------------------ RASTER ---------------------------
  async loadRasterLayer({ state, dispatch }, data) {
    state.rasterMarkerDate = data.params.TIME;

    if (data.NO_DATA || !data.params.TIME) {
      state.rasterFrontLayer.setVisible(false);
      state.rasterBackLayer.setVisible(false);

      return;
    }

    if (!(state.rasterFrontLayer &&
      state.rasterFrontLayer.get('service_id') === data.LAYER_SERVICE_ID &&
      state.rasterFrontLayer.get('layer_name') === data.params?.LAYERS
    )) {
      return await dispatch('createRasterLayer', data);
    }

    return await dispatch('updateRasterLayer', data);
  },
  async createRasterLayer({ state, dispatch }, data) {
    const projExtent = state.OLmap.getView().getProjection('EPSG:3857').getExtent();
    const startResolution = getWidth(projExtent);
    let resolutions = Array.apply(null, new Array(22));
    resolutions = resolutions.map((item, index) => item = startResolution / Math.pow(2, index));
    const tileGrid = new TileGrid({
      minZoom: 6,
      extent: projExtent,
      resolutions: resolutions,
      tileSize: [512, 512]
    });

    const makeLayer = () => {
      const rasterLayer = new TileLayer({
        // Commentato per far sì che il layer si ripeta su tutte le mappe
        // extent: data.EXTENT,
        zIndex: -1,
        opacity: state.sliderOpacityValue / 100,
        source: new TileWMS({
          url: data.url,
          params: data.params,
          serverType: 'geoserver',
          tileGrid: tileGrid,
          transition: 0, // niente fade
          crossOrigin: 'anonymous',
          hidpi: false
        })
      });

      rasterLayer.set('layer_type', data.TYPE);
      rasterLayer.set('layer_name', data.params.LAYERS);
      rasterLayer.set('layer_style', data.params.STYLES);
      rasterLayer.set('service_id', data.LAYER_SERVICE_ID);
      rasterLayer.set('service_name', data.params.SERVICE_NAME);
      rasterLayer.set('udm', data.UDM);
      rasterLayer.set('udm_conversions', data.UDM_CONVERSIONS);
      rasterLayer.set('is_multi_variable', data.IS_MULTI_VARIABLE || false);
      rasterLayer.set('multi_variable_layers', data.MULTI_VARIABLE_LAYERS || []);
      rasterLayer.set('multi_variable_layer_configs', data.MULTI_VARIABLE_LAYER_CONFIGS || []);

      state.OLmap.addLayer(rasterLayer);

      return rasterLayer;
    };

    state.rasterFrontLayer = makeLayer();
    state.rasterBackLayer = makeLayer();

    return new Promise((resolve) => {
      const onRenderComplete = () => {
        state.OLmap.un('rendercomplete', onRenderComplete);
        state.rasterFrontLayer.setZIndex(0);

        if (state.coordsLonLat.length === 2) {
          dispatch('setRasterMarkerValue');
        }

        resolve();
      };

      state.OLmap.once('rendercomplete', onRenderComplete);
      state.rasterFrontLayer.getSource().changed();
    });
  },
  async updateRasterLayer({ state, dispatch }, data) {
    const localISOTime = new Date(data.params.TIME).toISOString();
    // Aspetta finiscano i movimenti della mappa, zoom ecc
    // const view = state.OLmap.getView();
    // if (view.getInteracting() || view.getAnimating()) {
    //   await new Promise(resolve => state.OLmap.once('moveend', resolve));
    // }

    const front = state.rasterFrontLayer;
    const back = state.rasterBackLayer;
    const source = back.getSource();

    source.updateParams({
      ...source.getParams(),
      TIME: localISOTime
    });

    return new Promise((resolve) => {
      const onRenderComplete = () => {
        state.OLmap.un('rendercomplete', onRenderComplete);
        back.setZIndex(0);
        front.setZIndex(-1);

        state.rasterFrontLayer = back;
        state.rasterBackLayer = front;

        if (state.coordsLonLat.length === 2) {
          dispatch('setRasterMarkerValue');
        }

        resolve();
      };

      state.OLmap.once('rendercomplete', onRenderComplete);
      state.rasterBackLayer.setVisible(true); // in caso fosse nascosta per mancanza di dati
      source.changed();
    });
  },
  // ------------------------ VECTOR ---------------------------
  async createVectorLayer({ state, dispatch }, data) {
    const existingLayer = state.OLmap.getLayers().getArray().slice(1).find(l =>
      l.get('layer_name') === data.params.LAYERS &&
      l.get('service_id') === data.LAYER_SERVICE_ID
    );

    if (existingLayer) {
      return await dispatch('updateVectorLayer', data);
    }

    const vectorSource = new VectorSource({ format: new GeoJSON() });
    const [ws_name, layer_name] = data.params.LAYERS.split(':');
    const isStation = ws_name.includes('STATION') && layer_name !== 'lightning';
    const isLightining = (ws_name === 'STATION' || ws_name === 'LIGHTNING') && layer_name === 'lightning';
    const isActiveFire = ws_name.includes('SATELLITE') && layer_name === 'fire_sentinel3';

    try {
      const viewportExtent = state.OLmap.getView().calculateExtent(state.OLmap.getSize());
      state.vectorBBOX = getWorldAlignedBBox(viewportExtent, data.EXTENT);
      const paramRange = state.vectorParamRange?.[data.LAYER_SERVICE_ID] || data.params.PARAM_RANGE;
      const contain = containsExtent(data.EXTENT, state.vectorBBOX);
      const intersect = intersects(data.EXTENT, state.vectorBBOX);

      if (contain || intersect) {
        const resp = await getVectorLayer(
          data.params.LAYERS,
          state.vectorBBOX,
          data.params.TIME,
          data.params.USERNAME,
          data.params.SERVICE_NAME,
          undefined, //feature_id
          router.currentRoute.params.id,
          paramRange,
          false,
          data.AGGREGATION_INTERVAL,
          data.UDM_CONVERSIONS
        );
        let features = new GeoJSON().readFeatures(resp.data).filter(f => f.values_?.standard_property !== null);

        if (isStation) {
          features = await dispatch('poissonFilterFeatures', [features, layer_name]);
        }

        features = await dispatch('expandFeaturesFromGeomProperty', features);

        vectorSource.addFeatures(features);
      }
    } catch (err) {
      log.error('vector load', err);
      dispatch(
        'storeToastMessage',
        {
          text: 'vector load',
          errObj: {
            errors: [{ message: `LAYER: ${data.params.LAYERS} ERROR: ${err.response?.data?.MESSAGE || err.message}` }]
          },
          type: 'danger'
        },
        { root: true }
      );
    }

    await dispatch('getLegendVector', {
      layer_name: data.params.LAYERS,
      layer_style: data.params.STYLES
    });

    const vectorLayer = new VectorLayer({
      source: vectorSource,
      style: function (feature, resolution) {
        dispatch('getColorFill', [
          feature.get('standard_property'),
          feature.get('type_property'),
          feature.get('geom_property'),
          data.params.LAYERS
        ]);

        const stroke = new Stroke({ color: state.colorStroke[data.params.LAYERS], width: state.strokeWidth[data.params.LAYERS] });
        const fill = new Fill({ color: state.colorFill[data.params.LAYERS] });
        const text = (feature.get('standard_property') >= 0 || feature.get('standard_property') < 0) ? feature.get('standard_property').toString() : '-';

        let x = feature.get('standard_property');
        x = Number(String(x).replace(/[^0-9]/g, ''));
        let addition = 0;

        if (feature.get('standard_property') < 1) {
          if (feature.get('standard_property') > -1 && feature.get('standard_property') < 0) {
            addition = 3;
          } else {
            addition = (feature.get('standard_property') == 0) ? 1 : 2;
          }
        } else {
          addition = 1;
        }

        state.selectedFeatureDigits = (Math.log10((x ^ (x >> 31)) - (x >> 31)) | 0) + addition;
        let padding = [5, 5, 5, 5];

        switch (state.selectedFeatureDigits) {
          case 1:
            padding = [5, 18, 5, 18];
            break;
          case 2:
            padding = [5, 13, 5, 13];
            break;
          case 3:
            padding = [5, 9, 5, 9];
            break;
          default:
            padding = [5, 5, 5, 5];
            break;
        }

        if (feature.get('virtual_station')) {
          const virtualStationTextStyle = new Text({
            font: 'bold 24px Open Sans',
            textAlign: 'center',
            textBaseline: 'middle',
            fill: new Fill({ color: 'black' }),
            placement: 'point',
            padding: padding,
            text: text
          });

          const virtualStationStyle = new Style({
            image: new Circle({
              radius: 50,
              fill: fill,
              stroke: new Stroke({ color: 'black', width: 6 })
            }),
            text: virtualStationTextStyle,
            zIndex: state.zIndexValue[data.params.LAYERS] || 0
          });

          return virtualStationStyle;
        }

        if (isStation) {
          const [r, g, b] = getRgbFromColor(fill.getColor());

          const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
          const textColor = luminance < 140 ? 'white' : 'black';
          // padding = [2, 4, 2, 4];

          const stationStyle = new Style({
            renderer(coordinates, state) {
              const ctx = state.context;
              const paddingX = padding[1] * state.pixelRatio;
              const paddingY = padding[0] * state.pixelRatio;
              const radius = 6 * state.pixelRatio;
              ctx.font = `bold ${12 * state.pixelRatio}px Open Sans`;
              const textWidth = ctx.measureText(text).width;
              const width = textWidth + paddingX * 2;
              const height = (16 * state.pixelRatio) + paddingY * 2;
              const x = coordinates[0] - width / 2;
              const y = coordinates[1] - height / 2;

              // 👉 funzione locale
              function drawRoundedRect(x, y, w, h, r) {
                ctx.beginPath();
                ctx.moveTo(x + r, y);
                ctx.lineTo(x + w - r, y);
                ctx.quadraticCurveTo(x + w, y, x + w, y + r);
                ctx.lineTo(x + w, y + h - r);
                ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
                ctx.lineTo(x + r, y + h);
                ctx.quadraticCurveTo(x, y + h, x, y + h - r);
                ctx.lineTo(x, y + r);
                ctx.quadraticCurveTo(x, y, x + r, y);
                ctx.closePath();
              }

              // sfondo
              ctx.fillStyle = fill.color_;
              drawRoundedRect(x, y, width, height, radius);
              ctx.fill();

              ctx.lineWidth = 2;
              ctx.strokeStyle = `rgba(${Math.round(r * 0.7)}, ${Math.round(g * 0.7)}, ${Math.round(b * 0.7)}, 1)`;
              ctx.stroke();

              // testo
              ctx.fillStyle = textColor;
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillText(text, coordinates[0], coordinates[1]);
            },
            zIndex: state.zIndexValue[data.params.LAYERS] || 0
          });

          return stationStyle;
        }

        if (isActiveFire) {
          const FIRE_ICON_SCALE_STEPS = [
            { max: 5, scale: 0.5 },
            { max: 50, scale: 0.75 },
            { max: 100, scale: 1 },
            { max: 300, scale: 1.5 },
            { max: Infinity, scale: 2 }
          ];

          const standardProperty = Number(feature.get('standard_property')) || 0;
          const stepScale = FIRE_ICON_SCALE_STEPS.find(step => standardProperty <= step.max).scale;

          // Sotto lo zoom di default (5) l'icona smette di restare
          // a dimensione fissa in pixel e comincia a rimpicciolire
          const ZOOM_OUT_REFERENCE_RESOLUTION = 4892; // m/px
          const ZOOM_OUT_MIN_FACTOR = 0.35;
          const zoomOutFactor = resolution > ZOOM_OUT_REFERENCE_RESOLUTION
            ? Math.max(ZOOM_OUT_MIN_FACTOR, ZOOM_OUT_REFERENCE_RESOLUTION / resolution)
            : 1;
          const scale = stepScale * zoomOutFactor;

          const flameSvg = `<svg width="20px" height="20px" viewBox="-3 -1 32 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">
            <g transform="translate(-417.000000, -413.000000)" fill="${fill.color_}" stroke="${stroke.color_}">
              <path d="M439.905,419.953 C435.52,421.203 434.717,424.748 435,427 C431.872,423.322 432,419.093 432,413 C421.968,416.783 424.301,427.688 424,431 C421.477,428.935 421,424 421,424 C418.336,425.371 417,429.031 417,432 C417,439.18 422.82,445 430,445 C437.18,445 443,439.18 443,432 C443,427.733 439.867,425.765 439.905,419.953" id="flame-fire" sketch:type="MSShapeGroup">
              </path>
            </g>
          </svg>`;

          const activeFireStyle = new Style({
            image: new Icon({
              src: 'data:image/svg+xml;base64,' + btoa(flameSvg),
              scale: scale,
              anchor: [0.5, 0.5] // Ancora alla base della fiamma
            }),
            zIndex: standardProperty || 0
          });

          return activeFireStyle;
        }

        if (isLightining) {
          // Dimensione del fulmine proporzionale allo zoom.
          const LIGHTNING_ICON_SIZE = 16; // px desiderati al livello di zoom di riferimento
          const LIGHTNING_ICON_ARTWORK_SIZE = 512; // dimensione (px) del disegno originale del fulmine
          const lightningBorderWidth = 16; // spessore visibile desiderato per ciascun bordo (come impostazione attuale)
          const lightningInnerStroke = lightningBorderWidth * 2; // stroke nero effettivo da disegnare (2x per avere visibilità esterna pari a lightningBorderWidth)
          const lightningOuterBorderWidth = lightningBorderWidth * 4; // stroke bianco più largo in modo che la parte esterna visibile sia pari a lightningBorderWidth
          const LIGHTNING_ICON_PADDING = lightningOuterBorderWidth; // margine attorno al disegno per non tagliare il bordo bianco esterno (metà del suo stroke-width)
          const LIGHTNING_ICON_NATIVE_SIZE = LIGHTNING_ICON_ARTWORK_SIZE + LIGHTNING_ICON_PADDING * 2; // dimensione (px) del viewBox dell'SVG sorgente, disegno + margine
          const LIGHTNING_REFERENCE_RESOLUTION = 4892; // m/px allo zoom di riferimento (livello 5)
          const LIGHTNING_MIN_ZOOM = 3; // minZoom della View (vedi minZoom: 3 sulla View della mappa)
          const LIGHTNING_REFERENCE_ZOOM = 5;
          const LIGHTNING_MIN_SCALE_FACTOR = 0.5; // dimensione minima, raggiunta esattamente al minZoom
          const LIGHTNING_MAX_SCALE_FACTOR = 3; // tetto di sicurezza per zoom molto profondi
          const LIGHTNING_ZOOM_IN_GROWTH_PER_LEVEL = 1.1; // +10% di dimensione per ogni livello di zoom in avanti

          const zoomLevelOffset = Math.log2(LIGHTNING_REFERENCE_RESOLUTION / resolution);
          let lightningScaleFactor;

          if (zoomLevelOffset >= 0) {
            lightningScaleFactor = Math.pow(LIGHTNING_ZOOM_IN_GROWTH_PER_LEVEL, zoomLevelOffset);
          } else {
            const minZoomOffset = LIGHTNING_MIN_ZOOM - LIGHTNING_REFERENCE_ZOOM;
            const zoomOutRatio = Math.min(1, zoomLevelOffset / minZoomOffset);
            lightningScaleFactor = 1 - zoomOutRatio * (1 - LIGHTNING_MIN_SCALE_FACTOR);
          }

          lightningScaleFactor = Math.min(
            LIGHTNING_MAX_SCALE_FACTOR,
            Math.max(LIGHTNING_MIN_SCALE_FACTOR, lightningScaleFactor)
          );

          const lightningIconScale = (LIGHTNING_ICON_SIZE / LIGHTNING_ICON_ARTWORK_SIZE) * lightningScaleFactor;
          const lightningPathD = 'm 170.65808,1049.7159 c 0.64057,-2.2277 18.18006,-66.93491 38.97663,-143.79366 20.7966,-76.85875 38.25167,-141.33807 38.78907,-143.28739 0.53742,-1.94932 0.18733,-3.53542 -0.77792,-3.52467 -0.96528,0.0101 -31.82814,5.37779 -68.58415,11.92678 -36.75602,6.54899 -66.93352,11.78057 -67.06112,11.62574 -0.18024,-0.21871 40.74345,-154.11164 61.06724,-229.64262 l 3.40594,-12.6579 64.42076,0 64.42076,0 -24.10882,72.26871 c -13.25987,39.74779 -23.79348,72.58409 -23.40802,72.96958 0.38546,0.38549 32.76507,-4.6541 71.95467,-11.19906 52.26031,-8.72789 70.97961,-11.18527 70.22505,-9.21878 -1.52635,3.97787 -226.35532,384.19257 -228.58027,386.55857 -1.21173,1.2886 -1.48083,0.5519 -0.73982,-2.0253 z';

          const lightningSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="${LIGHTNING_ICON_NATIVE_SIZE}" height="${LIGHTNING_ICON_NATIVE_SIZE}" viewBox="-${LIGHTNING_ICON_PADDING} -${LIGHTNING_ICON_PADDING} ${LIGHTNING_ICON_NATIVE_SIZE} ${LIGHTNING_ICON_NATIVE_SIZE}">
            <g transform="translate(0,-512)">
              <path fill="none" stroke="rgba(255,255,255,1)" stroke-width="${lightningOuterBorderWidth}" stroke-linejoin="round" d="${lightningPathD}" />
              <path fill="${fill.color_}" stroke="rgba(0,0,0,1)" stroke-width="${lightningInnerStroke}" stroke-linejoin="round" d="${lightningPathD}" />
            </g>
          </svg>`;

          const lightningStyle = new Style({
            image: new Icon({
              src: 'data:image/svg+xml;base64,' + btoa(lightningSvg),
              scale: lightningIconScale,
              anchor: [0.5, 0.5]
            }),
            zIndex: state.zIndexValue[data.params.LAYERS] || 0
          });

          return lightningStyle;
        }

        if (feature.get('geometry').flatCoordinates.length <= 2) {
          if (feature.get('geom_property') || feature.get('standard_property') >= 0 || feature.get('standard_property') < 0) {
            if (feature.get('geom_property')) {
              const circleStyle = new Style({
                image: new Circle({
                  radius: 7,
                  fill: fill,
                  stroke: stroke
                }),
                zIndex: state.zIndexValue[data.params.LAYERS] || 0
              });

              return circleStyle;
            } else {
              const textStyle = new Text({
                font: 'bold 12px Open Sans',
                textAlign: 'center',
                textBaseline: 'middle',
                fill: new Fill({ color: 'black' }),
                placement: 'point',
                backgroundFill: fill,
                backgroundStroke: stroke,
                padding: padding,
                text: text
              });

              const pointStyle = new Style({
                image: new RegularShape({
                  points: 4,
                  radius: 10,
                  angle: Math.PI / 4
                }),
                text: textStyle,
                zIndex: state.zIndexValue[data.params.LAYERS] || 0
              });

              return pointStyle;
            }
          } else {
            const circleStyle = new Style({
              image: new Circle({
                radius: 7,
                fill: fill,
                stroke: stroke
              }),
              zIndex: state.zIndexValue[data.params.LAYERS] || 0
            });

            return circleStyle;
          }
        } else {
          const polygonStyle = new Style({
            stroke: stroke,
            fill: fill,
            zIndex: state.zIndexValue[data.params.LAYERS] || 0
          });

          return polygonStyle;
        }
      }
    });

    vectorLayer.set('layer_type', data.TYPE);
    vectorLayer.set('layer_name', data.params.LAYERS);
    vectorLayer.set('layer_style', data.params.STYLES);
    vectorLayer.set('service_id', data.LAYER_SERVICE_ID);
    vectorLayer.set('service_name', data.params.SERVICE_NAME);
    vectorLayer.set('time', data.params.TIME);
    vectorLayer.set('aggregation_interval', data.AGGREGATION_INTERVAL);
    vectorLayer.set('udm', data.UDM);
    vectorLayer.set('udm_conversions', data.UDM_CONVERSIONS);

    dispatch('checkOpacityServiceID', data.LAYER_SERVICE_ID);
    vectorLayer.setOpacity(state.sliderOpacityValue / 100);
    vectorLayer.setZIndex(1);
    state.OLmap.addLayer(vectorLayer);

    if (vectorLayer._vectorUpdateHandler) {
      state.OLmap.un('moveend', state._vectorUpdateHandler);
    }

    vectorLayer._vectorUpdateHandler = async () => {
      try {
        await dispatch('updateVectorLayer', {
          params: {
            ...data.params,
            TIME: vectorLayer.get('time'),
            PARAM_RANGE: state.vectorParamRange?.[data.LAYER_SERVICE_ID] || data.params.PARAM_RANGE
          },
          TYPE: 'VECTOR',
          LAYER_SERVICE_ID: data.LAYER_SERVICE_ID,
          EXTENT: data.EXTENT,
          AGGREGATION_INTERVAL: data.AGGREGATION_INTERVAL ?? null,
          UDM_CONVERSIONS: data.UDM_CONVERSIONS
        });
      } catch (err) {
        log.error('Errore reload su moveend', err);
      }
    };

    state.OLmap.on('moveend', vectorLayer._vectorUpdateHandler);

    return Promise.resolve();
  },
  async updateVectorLayer({ state, dispatch }, data) {
    const existingLayer = state.OLmap.getLayers().getArray().find(l =>
      l.get('layer_name') === data.params.LAYERS &&
      l.get('service_id') === data.LAYER_SERVICE_ID
    );

    if (!existingLayer) {
      return;
    }

    existingLayer.set('time', data.params.TIME);

    try {
      const vectorSource = existingLayer.getSource();
      const viewportExtent = state.OLmap.getView().calculateExtent(state.OLmap.getSize());

      state.vectorBBOX = getWorldAlignedBBox(viewportExtent, data.EXTENT);
      const contain = containsExtent(data.EXTENT, state.vectorBBOX);
      const intersect = intersects(data.EXTENT, state.vectorBBOX);
      const paramRange = state.vectorParamRange?.[data.LAYER_SERVICE_ID] || data.params.PARAM_RANGE;

      if (contain || intersect) {
        const resp = await getVectorLayer(
          data.params.LAYERS,
          state.vectorBBOX,
          data.params.TIME,
          data.params.USERNAME,
          data.params.SERVICE_NAME,
          undefined, //feature_id
          router.currentRoute.params.id,
          paramRange,
          false,
          data.AGGREGATION_INTERVAL,
          data.UDM_CONVERSIONS
        );
        let features = new GeoJSON().readFeatures(resp.data).filter(f => f.values_?.standard_property !== null);
        const [ws_name, layer_name] = data.params.LAYERS.split(':');
        const isStation = ws_name.includes('STATION') && layer_name !== 'lightning';

        if (isStation) {
          features = await dispatch('poissonFilterFeatures', [features, layer_name]);
        }

        features = await dispatch('expandFeaturesFromGeomProperty', features);

        const selectedFeature = features.find(f => {
          return f.get('ignore_id') === state.selectedFeatureCheckParam ||
          f.get('radarmeteo_id') === state.selectedFeatureCheckParam ||
          f.get('area') === state.selectedFeatureCheckParam ||
          f.get('Area') === state.selectedFeatureCheckParam;
        });

        if (state.selectedFeatureServiceID === data.LAYER_SERVICE_ID) {
          if (selectedFeature) {
            state.selectedFeatureObj = selectedFeature.getProperties();
            state.selectedFeatureLayerName = data.params.LAYERS;
            const featurePosition = getFeaturePosition(selectedFeature);

            if (state.selectedFeaturePosition[0] !== featurePosition[0]
              && state.selectedFeaturePosition[1] !== featurePosition[1]
            ) {
              state.selectedFeaturePosition = featurePosition;
              state.popup.setPosition(featurePosition);
            }

          } else {
            dispatch('closePopupOnMap');
          }
        }

        vectorSource.clear();
        vectorSource.addFeatures(features);
      } else {
        vectorSource.clear();
      }

      return Promise.resolve();
    } catch (err) {
      log.error('Animazione layer', err);
      throw err;
    }
  },
  async poissonFilterFeatures({ state }, [features, layer_name]) {
    const map = state.OLmap;
    const zoom = Math.floor(map.getView().getZoom());
    const prevZoom = state.lastZoom ?? zoom;

    if (zoom >= 9) {
      state.lastZoom = zoom;

      return features;
    }

    const key = layer_name + '_' + zoom;
    const prevKey = layer_name + '_' + prevZoom;

    const baseRadius = 180000;
    const radius = baseRadius / Math.pow(2, zoom - 5);
    const radiusSq = radius * radius;

    const extent = map.getView().calculateExtent(map.getSize());
    const center = [
      (extent[0] + extent[2]) / 2,
      (extent[1] + extent[3]) / 2
    ];

    const distanceSq = (a, b) => {
      const dx = a[0] - b[0];
      const dy = a[1] - b[1];

      return dx * dx + dy * dy;
    };

    const getFeaturesFromIds = (ids) => {
      const set = new Set(ids);

      return features.filter(f => set.has(f.get('ignore_id')));
    };

    // FEATURES PRECEDENTI (per stabilità visiva)
    let previousFeatures = [];

    if (state.savedGridFeatures[prevKey]) {
      previousFeatures = getFeaturesFromIds(state.savedGridFeatures[prevKey]);
    }

    const prevIds = new Set(previousFeatures.map(f => f.get('ignore_id')));

    // ORDINAMENTO
    const sorted = [...features].sort((a, b) => {
      const aPrev = prevIds.has(a.get('ignore_id')) ? 0 : 1;
      const bPrev = prevIds.has(b.get('ignore_id')) ? 0 : 1;

      if (aPrev !== bPrev) {
        return aPrev - bPrev;
      }

      const da = distanceSq(a.getGeometry().getCoordinates(), center);
      const db = distanceSq(b.getGeometry().getCoordinates(), center);

      return da - db;
    });

    // Spatial grid (solo per lookup veloce)
    const cellSize = radius;
    const grid = new globalThis.Map();

    const getCellKey = (coord) => {
      const x = Math.floor(coord[0] / cellSize);
      const y = Math.floor(coord[1] / cellSize);

      return `${x}_${y}`;
    };

    const getNeighborCells = (coord) => {
      const x = Math.floor(coord[0] / cellSize);
      const y = Math.floor(coord[1] / cellSize);
      const cells = [];

      for (let dx = -1;dx <= 1;dx++) {
        for (let dy = -1;dy <= 1;dy++) {
          cells.push(`${x + dx}_${y + dy}`);
        }
      }

      return cells;
    };

    const selected = [];
    const selectedIds = [];

    for (const feature of sorted) {
      const coord = feature.getGeometry().getCoordinates();

      let tooClose = false;

      const neighborCells = getNeighborCells(coord);

      for (const cellKey of neighborCells) {
        if (!grid.has(cellKey)) {
          continue;
        }

        for (const other of grid.get(cellKey)) {
          if (distanceSq(coord, other) < radiusSq) {
            tooClose = true;
            break;
          }
        }

        if (tooClose) {
          break;
        }
      }

      if (!tooClose) {
        selected.push(feature);
        selectedIds.push(feature.get('ignore_id'));
        const cellKey = getCellKey(coord);

        if (!grid.has(cellKey)) {
          grid.set(cellKey, []);
        }

        grid.get(cellKey).push(coord);
      }
    }

    state.savedGridFeatures[key] = selectedIds;
    state.lastZoom = zoom;

    return selected;
  },
  async expandFeaturesFromGeomProperty({ state }, features) {
    const createFeatureFromGeometry = (geometry, properties) => {
      switch (geometry.type) {
        case 'Point':
          return new Feature({ geometry: new Point(geometry.coordinates), ...properties });
        case 'LineString':
          return new Feature({ geometry: new LineString(geometry.coordinates), ...properties });
        case 'Polygon':
          return new Feature({ geometry: new Polygon(geometry.coordinates), ...properties });
        case 'MultiPolygon':
          return new Feature({ geometry: new MultiPolygon(geometry.coordinates), ...properties });
        default:
          return null;
      }
    };

    let isGeomProperty = false;

    const addFeatureIfExists = (property, feature) => {
      if (feature.get(property)) {
        // eslint-disable-next-line no-unused-vars
        const { geometry, ...values } = feature.getProperties();
        const newFeature = createFeatureFromGeometry(feature.get(property), {
          ...values,
          geom_property: property,
          added_feature: true
        });

        if (newFeature) {
          features.push(newFeature);
          isGeomProperty = true;
        }
      }
    };

    features.forEach(f => {
      const geometries = Object.keys(f.getProperties()).filter(e =>
        typeof f.get(e) === 'object' &&
        f.get(e)?.type &&
        !state.ignoreProperties.includes(e)
      );
      state.ignoreProperties.push(...geometries);
    });

    if (state.ignoreProperties.length > 7) {
      features.forEach(f => {
        state.ignoreProperties.slice(7).forEach(property => {
          addFeatureIfExists(property, f);
        });
      });
    }

    if (isGeomProperty) {
      features.forEach(f => {
        if (!f.getProperties().added_feature) {
          f.set('geom_property', 'geom');
        }
      });
    }

    return features;
  },
  async resetAnimationTime({ state }) {
    window.clearInterval(state.animationInterval);
    state.animationInterval = null;
    state.disableAnimationPlay = false;
    state.isAnimating = [];
  },
  async setGlobalLayer({ dispatch, rootState, state }, [globalLayer, type]) {
    const index = rootState.global_layers.selectedGlobalLayer.indexOf(globalLayer);
    const selectedGlobalLayer = rootState.global_layers.selectedGlobalLayer[index] || '';

    if (selectedGlobalLayer !== '') {
      const items = {
        Bucket: S3_BUCKETS.global_layer(),
        Key: `${globalLayer.layer_polygon}`
      };
      const data = [items, globalLayer.color, globalLayer.width, globalLayer.layer_name, type];

      if (globalLayer.layer_type === 'geojson') {
        await dispatch('openGEOJSON', data);
      }

      if (globalLayer.layer_type === 'kml') {
        await dispatch('openKML', data);
      }

      if (globalLayer.layer_type === 'shp') {
        await dispatch('openSHP', data);
      }

      dispatch('setGlobalLayersInteractions', data);
    } else {
      if (rootState.app_user.defaultService.GLOBAL?.customer_layer_id) {
        const CLindex = rootState.app_user.defaultService.GLOBAL.customer_layer_id.findIndex(item => item.id === globalLayer.global_layer_id);

        if (CLindex >= 0) {
          rootState.app_user.defaultService.GLOBAL.customer_layer_id.splice(CLindex, 1);
        }
      }

      if (rootState.app_user.defaultService.GLOBAL?.global_layer_id) {
        const GLindex = rootState.app_user.defaultService.GLOBAL.global_layer_id.findIndex(item => item.id === globalLayer.global_layer_id);

        if (GLindex >= 0) {
          rootState.app_user.defaultService.GLOBAL.global_layer_id.splice(GLindex, 1);
        }
      }

      const interactionsToRemove = [];
      const mapInteractions = state.OLmap.getInteractions();
      mapInteractions.forEach(interaction => {
        if (interaction.values_.layer_name === globalLayer.layer_name) {
          interactionsToRemove.push(interaction);
        }
      });
      interactionsToRemove.forEach(e => state.OLmap.removeInteraction(e));
      await dispatch('removeLayer', globalLayer.layer_name);

      const overlayEl = state.globalLayerPopup.getElement();

      if (!overlayEl) {
        return;
      }

      const contentEl = overlayEl.querySelector('.overlay-style');

      if (!contentEl) {
        return;
      }

      const nodesToRemove = [];
      let node = contentEl.firstChild;

      while (node) {
        if (node.tagName === 'H3' && node.textContent === globalLayer.layer_name) {
          const prev = node.previousSibling;

          if (prev && prev.tagName === 'HR' && prev.getAttribute('style') === 'border-top:1px solid rgba(255,255,255,0.15); margin:6px 0;') {
            nodesToRemove.push(prev);
          }

          nodesToRemove.push(node);
          let next = node.nextSibling;

          while (next && next.tagName !== 'H3') {
            nodesToRemove.push(next);
            next = next.nextSibling;
          }

          break;
        }

        node = node.nextSibling;
      }

      nodesToRemove.forEach(n => contentEl.contains(n) && contentEl.removeChild(n));

      if (!contentEl.hasChildNodes()) {
        overlayEl.style.display = 'none';
      }
    }
  },
  async openGEOJSON({ state }, data) {
    const [obj, color, width, layer_name, type] = data;
    let response = '';

    try {
      const s3_bucket = new AWS.S3();
      response = await s3_bucket.getSignedUrlPromise('getObject', obj);
    } catch (err) {
      log.error('Global Layer err', err);
    }

    if (response) {
      const source = new VectorSource({
        format: new GeoJSON(),
        url: response
      });
      const styles = [new Style({
        image: new Circle({
          radius: width,
          fill: new Fill({ color: color }),
          stroke: new Stroke({ color: color, width: 1 })
        })
      }),
      new Style({
        stroke: new Stroke({
          color: color || '',
          width: width || ''
        })
      })];

      const vector = new VectorLayer({
        source: source,
        style: styles
      });

      vector.set('layer_type', type);
      vector.set('layer_name', layer_name);
      state.OLmap.addLayer(vector);
      state.OLmap.getLayers().getArray()[1].getSource().changed();
    }
  },
  async openKML({ dispatch, state }, data) {
    const [obj, color, width, layer_name, type] = data;
    const s3_bucket = new AWS.S3();
    const response = await s3_bucket.getSignedUrlPromise('getObject', obj);

    if (response) {
      const vector = new VectorLayer({
        source: new VectorSource({
          url: response,
          format: new KMLSource({
            extractStyles: false
          })
        }),
        style: [new Style({
          image: new Circle({
            radius: width,
            fill: new Fill({ color: color }),
            stroke: new Stroke({ color: color, width: 1 })
          })
        }),
        new Style({
          stroke: new Stroke({
            color: color,
            width: width
          })
        })]
      });
      vector.set('layer_type', type);
      vector.set('layer_name', layer_name);
      state.OLmap.addLayer(vector);
    } else {
      dispatch(
        'storeToastMessage',
        {
          text: 'KML Layer Link failed',
          type: 'error'
        },
        { root: true }
      );
    }
  },
  async openSHP({ state, dispatch }, data) {
    const [obj, color, width, layer_name, type] = data;
    const s3_bucket = new AWS.S3();
    const response = await s3_bucket.getSignedUrlPromise('getObject', obj);

    if (response) {
      shp(response).then(async function (geojson) {
        const source = new VectorSource();
        const vector = new VectorLayer({
          source: source,
          style: [new Style({
            image: new Circle({
              radius: width,
              fill: new Fill({ color: color }),
              stroke: new Stroke({ color: color, width: 1 })
            })
          }),
          new Style({
            stroke: new Stroke({
              color: color,
              width: width
            })
          })]
        });

        vector.set('layer_type', type);
        vector.set('layer_name', layer_name);
        await state.OLmap.addLayer(vector);
        await source.addFeatures(new GeoJSON({ featureProjection: 'EPSG:3857' }).readFeatures(geojson));
        state.OLmap.getLayers().getArray()[1].getSource().changed();
      });
    } else {
      dispatch(
        'storeToastMessage',
        {
          text: 'Error Link failed',
          type: 'error'
        },
        { root: true }
      );
    }
  },
  setGlobalLayersInteractions({ state }, data) {
    // eslint-disable-next-line no-unused-vars
    const [obj, color, width, layer_name] = data;

    const interactionStyles = [new Style({
      image: new Circle({
        radius: width + 5,
        fill: new Fill({ color: color }),
        stroke: new Stroke({ color: color, width: 1 })
      })
    }),
    new Style({
      stroke: new Stroke({
        color: color,
        width: width + 5
      })
    })];

    const clickInteraction = new Select({
      layers: function (layer) {
        return layer.values_.layer_name === layer_name && !state.isVectorPopup;
      },
      condition: singleClick,
      style: interactionStyles
    });

    const hoverInteraction = new Select({
      layers: function (layer) {
        return layer.values_.layer_name === layer_name && !state.isVectorPopup;
      },
      condition: pointerMove,
      style: interactionStyles
    });

    clickInteraction.on('select', (event) => {
      // Raccogli tutte le features evidenziate dagli hoverInteraction attivi
      const hoveredFeatures = [];
      state.OLmap.getInteractions().forEach(inter => {
        if (inter instanceof Select && inter.get('layer_name') && inter.get('type') === 'CLICK') {
          inter.getFeatures().forEach(f => {
            // aggiungi il nome del layer come proprietà temporanea
            f._layerName = inter.get('layer_name');
            hoveredFeatures.push(f);
          });
        }
      });

      if (hoveredFeatures.length > 0 && !state.isVectorPopup) {
        const propsList = hoveredFeatures.map(feature => {
          const properties = feature.getProperties();
          const layerName = feature._layerName || 'Layer sconosciuto';
          let isFirstItem = true;
          let resultString = `<h3 class="mb-2">${layerName}</h3>`;

          resultString += Object.keys(properties)
            .filter(item => item !== 'geometry')
            .map(item => {
              const result = (isFirstItem ? '' : '<br />') + `<span><b>${item}:</b> ${properties[item]}</span>`;
              isFirstItem = false;

              return result;
            })
            .join('');

          return resultString;
        });

        state.globalLayerPopup.setPosition(event.mapBrowserEvent.coordinate);
        state.globalLayerPopup.getElement().innerHTML = `
          <style>
            .overlay-style {
              color: white;
              font: 12px Open Sans;
              padding: 5px 10px;
              background-color: rgba(0, 0, 0, 0.7);
              border: 1px solid green;
              border-radius: 5px;
              z-index: 100;
              max-height: 500px;
              max-width: 300px;
              overflow-y: auto;
            }
          </style>
          <div class="overlay-style">${propsList.join('<hr style="border-top:1px solid rgba(255,255,255,0.15); margin:6px 0;" />')}</div>`;
        state.globalLayerPopup.getElement().style.display = 'block';
      } else {
        state.globalLayerPopup.getElement().style.display = 'none';
      }
    });

    clickInteraction.set('layer_name', layer_name);
    clickInteraction.set('type', 'CLICK');
    hoverInteraction.set('layer_name', layer_name);
    hoverInteraction.set('type', 'HOVER');

    state.OLmap.addInteraction(clickInteraction);
    state.OLmap.addInteraction(hoverInteraction);
  },
  // ------------------------ LEGEND ---------------------------
  async getLegendVector({ state, dispatch }, data) {
    try {
      const legend = await dispatch(
        'getLegend',
        {
          layer_name: data.layer_name,
          layer_style: data.layer_style,
          layer_type: 'VECTOR'
        },
        { root: true }
      );

      state.legend_vectorRules[data.layer_name] = [];
      legend.rules.forEach((item, index) => {
        if (item.symbolizers[0].Point) {
          const color = item.symbolizers[0].Point.graphics[0].fill;
          const stroke = item.symbolizers[0].Point.graphics[0].stroke ?? 'black';
          const strokeWidth = item.symbolizers[0].Point.graphics[0]['stroke-width'];
          const [lowerBound, operator, upperBound] = item.name.split(',');
          state.legend_vectorRules[data.layer_name].push({
            lowerBound: lowerBound,
            operator: operator,
            upperBound: upperBound || '',
            color: color,
            stroke: stroke,
            strokeWidth: strokeWidth || 2,
            filter: (item.filter) ? item.filter.split('\'')[1] : '',
            zIndex: item.abstract?.zIndex || index
          });
        }

        if (item.symbolizers[0].Polygon) {
          const color = item.symbolizers[0].Polygon.fill;
          const stroke = item.symbolizers[0].Polygon.stroke ?? 'black';
          const strokeWidth = item.symbolizers[0].Polygon['stroke-width'];
          const [lowerBound, operator, upperBound] = item.name.split(',');
          state.legend_vectorRules[data.layer_name].push({
            lowerBound: operator ? lowerBound : item.filter.split('\'')[1],
            operator: operator || '=',
            upperBound: upperBound || '',
            color: color,
            stroke: stroke,
            strokeWidth: strokeWidth || 2,
            zIndex: item.abstract?.zIndex || index
          });
        }

        if (item.symbolizers[0].Line) {
          const color = item.symbolizers[0].Line.stroke;
          const strokeWidth = item.symbolizers[0].Line['stroke-width'];
          const [lowerBound, operator, upperBound] = item.name.split(',');
          state.legend_vectorRules[data.layer_name].push({
            lowerBound: operator ? lowerBound : item.filter.split('\'')[1],
            operator: operator || '=',
            upperBound: upperBound || '',
            color: color,
            stroke: color,
            strokeWidth: strokeWidth || 2,
            zIndex: item.abstract?.zIndex || index
          });
        }
      });

      if (state.legend_vectorRules[data.layer_name].some(e => e.lowerBound === 'geom_property')) {
        state.legend_vectorRules[data.layer_name].forEach(e => {
          e.geomType = e.operator;
          e.operator = '<';
          e.lowerBound = '1000';
        });
      }
    } catch (err) {
      dispatch(
        'storeToastMessage',
        {
          text: 'getLegendVector',
          errObj: {
            errors: [{ message: 'Error while fetching legend. Reload the Vector Layer.' }]
          },
          type: 'danger'
        },
        { root: true }
      );
    }
  },
  getColorFill({ state }, [standard_property, type_property, geom_property, layer_name]) {
    if (geom_property) {
      const vectorRule = state.legend_vectorRules[layer_name].find(r => r.geomType === geom_property);
      state.colorFill[layer_name] = vectorRule.color;
      state.colorStroke[layer_name] = vectorRule.stroke;
      state.strokeWidth[layer_name] = vectorRule.strokeWidth;
      state.zIndexValue[layer_name] = vectorRule.zIndex;
    } else {
      state.legend_vectorRules[layer_name].forEach(rule => {
        if (type_property >= 0 && type_property == rule.filter) {
          state.colorFill[layer_name] = rule.color;
          state.colorStroke[layer_name] = rule.stroke;
          state.strokeWidth[layer_name] = rule.strokeWidth;
          state.zIndexValue[layer_name] = rule.zIndex;
        }

        if (standard_property || standard_property === 0) {
          if (rule.upperBound !== '') {
            if (rule.operator === '<=' || rule.operator === '<') {
              if (standard_property > rule.lowerBound && `${standard_property} ${rule.operator} ${rule.upperBound}`) {
                state.colorFill[layer_name] = rule.color;
                state.colorStroke[layer_name] = rule.stroke;
                state.strokeWidth[layer_name] = rule.strokeWidth;
                state.zIndexValue[layer_name] = rule.zIndex;
              }
            }
          } else {
            if (rule.operator === '<' || rule.operator === '>' || rule.operator === '=') {
              if (rule.operator === '=') {
                if (standard_property == rule.lowerBound) {
                  state.colorFill[layer_name] = rule.color;
                  state.colorStroke[layer_name] = rule.stroke;
                  state.strokeWidth[layer_name] = rule.strokeWidth;
                  state.zIndexValue[layer_name] = rule.zIndex;
                }
              } else {
                if (`${standard_property} ${rule.operator} ${rule.lowerBound}`) {
                  state.colorFill[layer_name] = rule.color;
                  state.colorStroke[layer_name] = rule.stroke;
                  state.strokeWidth[layer_name] = rule.strokeWidth;
                  state.zIndexValue[layer_name] = rule.zIndex;
                }
              }
            }
          }
        } else {
          if (type_property == undefined) {
            state.colorFill[layer_name] = 'white';
            state.colorStroke[layer_name] = 'black';
            state.strokeWidth[layer_name] = 2;
            state.zIndexValue[layer_name] = 0;
          }
        }
      });
    }

    if (Array.isArray(state.colorFill[layer_name])) {
      state.colorFill[layer_name] = state.colorFill[layer_name][0];
    }

    if (Array.isArray(state.colorStroke[layer_name])) {
      state.colorStroke[layer_name] = state.colorStroke[layer_name][0];
    }
  }
};
